module.exports = __webpack_public_path__ + "static/media/hamburger-menu.bb2becc7.svg";